export default "__VITE_ASSET__Br$ewnI___"